import {gql} from '@apollo/client';

import {InstitutionSet} from '../fragment/generics/institution-set.fragment';
import {FullGroup} from '../fragment/generics/group.fragment';
import {ProfileImage} from '../fragment/generics/profile-image.fragment';
import {InstitutionDetails} from '../fragment/generics/institution-details.fragment';

export const FetchInstitutions = gql`
    query FetchInstitutions($institutionId: InstitutionId) {
        institutions(institutionId: $institutionId) {
            groups {
                ...FullGroup
            }
            profileImage {
                ...ProfileImage
            }
            title
            locale
            timeZone
            institutionId
            details {
                ...InstitutionDetails
            }
        }
    }
    ${InstitutionSet}
    ${FullGroup}
    ${ProfileImage}
    ${InstitutionDetails}
`;
